<template>
  <div class="edit-membership">
    <error :errors="membershipError" />
    <membership-form action="edit" />
  </div>
</template>

<script>
  import { SET_BREADCRUMB } from "@/store/breadcrumbs.module";
  import MembershipForm from "../../../components/membership/MembershipForm";
  import Error from "../../../partials/widgets/Error";
  import { mapGetters } from "vuex";
  export default {
    name: "index",
    components: { MembershipForm, Error },
    computed: {
      ...mapGetters(['membershipError'])
    },
    mounted() {
      this.$store.dispatch(SET_BREADCRUMB, [
        { title: "VIP ئەزالىق تۈرى باشقۇرۇش", route: "list" },
        { title: "ئۇچۇر تەھرىرلەش" }
      ]);
    }
  }
</script>

<style scoped>

</style>
